<rk-mobile-close-button class="fixed z-10" (click)="exitPanel()"></rk-mobile-close-button>
@if (track$ | async; as track) {
  <div class="p-5">
    <div class="line" (click)="editTrack()">
      <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    </div>
    <div class="line" (click)="downloadTrack(track)">
      <mat-icon fontSet="fa" fontIcon="fa-download"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DOWNLOAD</span>
    </div>
    @if ((playlists$ | async).length) {
      <div class="line" (click)="addToPlaylist(track.id)">
        <mat-icon fontSet="fa" fontIcon="fa-indent"></mat-icon>
        <span translate>MEDIA.TABLE.ADD_TO_PLAYLIST_BUTTON</span>
      </div>
    }
    <div class="line" (click)="moveTrack(track)">
      <mat-icon fontSet="fa" fontIcon="fa-arrow-right"></mat-icon>
      <span translate>MEDIA.TABLE.MOVE_BUTTON</span>
    </div>
    <div class="line delete" (click)="deleteTrack(track)">
      <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    </div>
  </div>
}
